import { Option } from 'components/ui/FormControls';

import { sortArray } from './sorting.utils';
import {
    CategoryItem,
    CategoryItemNode,
    CategoryItemByParent,
    ListItem,
} from '../shared/types';
import { baseUrls } from './baseUrls.utils';

export interface StaticItem {
    _id: string;
    name: string;
}
export const prepareStaticDataList = (items: StaticItem[] = []): Option[] => {
    const catList = sortArray(
        items.map(
            (x) =>
                ({
                    label: x.name,
                    value: x._id,
                }) as Option
        ),
        'label'
    );
    return catList;
};

export const getCategoryItem = (
    categories?: CategoryItem[],
    id?: string
): CategoryItem | undefined =>
    (categories || []).find((x: { _id: string }) => x._id === id) ?? undefined;

export const sortByParent = (
    source: CategoryItem[]
): CategoryItemByParent[] => {
    if (!source || source.length === 0) {
        return [];
    }

    const tmpList: CategoryItemByParent[] = [];

    const sortedList = source.slice().sort((a, b) => {
        const keyA = getSortKey(a);
        const keyB = getSortKey(b);
        if (keyA > keyB) return 1;
        if (keyB > keyA) return -1;

        return 0;
    });

    sortedList.forEach((item) => {
        if (!item.parent) {
            // handle parents
            tmpList.push({
                parentId: item._id,
                children: [item],
            });
        } else {
            // handle children
            const parent = tmpList.find((x) => x.parentId === item.parent);
            parent?.children.push(item);
        }
    });

    return tmpList;

    function getSortKey(item: CategoryItem): string {
        return item.parent
            ? '1#' + item.name.toLowerCase()
            : '0#' + item.name.toLowerCase();
    }
};

export const getLinkPrefix = () => {
    return baseUrls.browse.main;
};

export const toListItem = (cat: CategoryItem): ListItem => {
    const sectionPart = `${baseUrls.browse.main}/`;

    return {
        id: cat._id,
        name: cat.name,
        url: sectionPart + cat._id,
    };
};

export const getCategoryItemFromTree = (
    categories?: CategoryItemNode[],
    id?: string
): CategoryItemNode | undefined => {
    if (!categories || categories.length === 0 || !id) return undefined;

    for (const item of categories) {
        if (item._id === id) return item;

        const found = getCategoryItemFromTree(item.children, id);
        if (found) return found;
    }

    return undefined;
};

function treeToList(
    categories: CategoryItemNode[],
    target: CategoryItemNode[],
    except: string[]
) {
    if (!categories || categories.length === 0) return;

    for (const item of categories) {
        if (except.includes(item._id)) continue;
        target.push(item);
        treeToList(item.children, target, except);
    }
}

export const getCategoriesAsList = (
    categories: CategoryItemNode[],
    except: string[]
): CategoryItemNode[] => {
    if (!categories || categories.length === 0) return [];

    const target: CategoryItemNode[] = [];

    treeToList(categories, target, except);

    return target;
};

function addNodeToList<T>(
    item: CategoryItemNode,
    targetList: T[],
    converter: (source: CategoryItemNode) => T
) {
    targetList.push(converter(item));

    for (const child of item.children) {
        addNodeToList(child, targetList, converter);
    }
}

export function categoriesToList<T>(
    items: CategoryItemNode[],
    converter: (source: CategoryItemNode) => T
): T[] {
    if (!items?.length) {
        return [];
    }
    const resultList: T[] = [];

    for (const child of items) {
        addNodeToList(child, resultList, converter);
    }

    return [...resultList];
}
